"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var bind_1 = require("../../bind");
var feedback_form_1 = require("./feedback_form");
var feedback_order_info_1 = require("./feedback_order_info");
var rql_1 = require("../../schemas/rql");
var feedback_seller_shop_info_1 = require("./feedback_seller_shop_info");
var feedback_shop_link_1 = require("./feedback_shop_link");
var decline_feedback_1 = require("./decline_feedback");
var LP_MERCHANDISING_TYPE = 'lp';
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_Feedback_OrderInfo(\n      $orderUuid: String\n      $buyerShopChannel: core_apimessages_Channel\n    ){\n      me {\n        uuid\n        orders(input: { uuids: [$orderUuid] }) {\n          legacyOrderId\n          buyerUuid\n          buyer {\n            name\n            shop(input: {channel: $buyerShopChannel}) {\n              name\n              slug\n            }\n          }\n          status\n          amountTotal {\n            amount\n            amountCents\n            currency\n            symbol\n            display\n          }\n          shippedAt {\n            seconds\n          }\n          createdAt {\n            seconds\n          }\n          listing {\n            id\n            slug\n            title\n            merchandisingType\n            shopUuid\n            images(input: { transform: \"thumb\", count: 1 }) {\n              source\n            }\n          }\n        }\n      }\n    }\n  "], ["\n    query Core_Feedback_OrderInfo(\n      $orderUuid: String\n      $buyerShopChannel: core_apimessages_Channel\n    ){\n      me {\n        uuid\n        orders(input: { uuids: [$orderUuid] }) {\n          legacyOrderId\n          buyerUuid\n          buyer {\n            name\n            shop(input: {channel: $buyerShopChannel}) {\n              name\n              slug\n            }\n          }\n          status\n          amountTotal {\n            amount\n            amountCents\n            currency\n            symbol\n            display\n          }\n          shippedAt {\n            seconds\n          }\n          createdAt {\n            seconds\n          }\n          listing {\n            id\n            slug\n            title\n            merchandisingType\n            shopUuid\n            images(input: { transform: \"thumb\", count: 1 }) {\n              source\n            }\n          }\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) {
        return {
            ssr: true,
            variables: {
                orderUuid: ownProps.orderUuid,
            },
        };
    },
});
var FeedbackContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FeedbackContainer, _super);
    function FeedbackContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            successMessage: null,
            errors: [],
        };
        return _this;
    }
    FeedbackContainer.prototype.updateFeedbackSuccess = function () {
        this.setState({ successMessage: I18n.t('discovery.feedbackContainer.feedbackSuccess') });
    };
    FeedbackContainer.prototype.updateFeedbackError = function (errors) {
        this.setState({
            errors: errors,
        });
    };
    FeedbackContainer.prototype.declineFeedbackSuccess = function () {
        this.setState({ successMessage: I18n.t('discovery.feedbackContainer.declineSuccess') });
    };
    FeedbackContainer.prototype.renderSuccessMessage = function () {
        return (React.createElement("div", { className: "bd-2 bd--offwhite bd--rounded scaling-padding-2" },
            React.createElement("div", { className: "alert-box alert-box--green align-center" }, this.state.successMessage)));
    };
    Object.defineProperty(FeedbackContainer.prototype, "order", {
        get: function () {
            return this.props.data.me.orders[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackContainer.prototype, "buyer", {
        get: function () {
            return this.order.buyer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackContainer.prototype, "isBuyer", {
        get: function () {
            return this.props.data.me.uuid === this.order.buyerUuid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackContainer.prototype, "isLp", {
        get: function () {
            return this.order.listing.merchandisingType === LP_MERCHANDISING_TYPE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackContainer.prototype, "channel", {
        get: function () {
            return this.isLp ? rql_1.core_apimessages_Channel.LP : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeedbackContainer.prototype, "loading", {
        get: function () {
            return this.props.data.loading !== false;
        },
        enumerable: true,
        configurable: true
    });
    FeedbackContainer.prototype.renderErrors = function () {
        if (this.state.errors.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "alert-box alert-box--red mb-2" }, this.state.errors[0].message));
    };
    FeedbackContainer.prototype.renderSellerShopInfo = function () {
        return (React.createElement(feedback_seller_shop_info_1.default, { listingId: this.order.listing.id, channel: this.channel }));
    };
    FeedbackContainer.prototype.renderBuyerShopInfo = function () {
        return (React.createElement(feedback_shop_link_1.default, { shop: this.buyer.shop, userName: this.buyer.name }));
    };
    FeedbackContainer.prototype.renderShopInfo = function () {
        if (this.isBuyer) {
            // if the author is the buyer, they are leaving feedback FOR the seller
            return this.renderSellerShopInfo();
        }
        return this.renderBuyerShopInfo();
    };
    FeedbackContainer.prototype.renderPlaceholder = function () {
        return (React.createElement("div", { className: "bd-2 bd--offwhite bd--rounded scaling-padding-2" },
            React.createElement("div", { className: "feedback-container feedback-container--placeholder" })));
    };
    FeedbackContainer.prototype.render = function () {
        if (this.loading) {
            return this.renderPlaceholder();
        }
        if (this.state.successMessage && this.state.successMessage.length > 0) {
            return this.renderSuccessMessage();
        }
        return (React.createElement("div", { className: "bd-2 bd--offwhite bd--rounded scaling-padding-2" },
            this.renderErrors(),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-5 g-col-mobile-12 mobile-mb-1 size-90" },
                    this.renderShopInfo(),
                    React.createElement(feedback_order_info_1.default, { order: this.order, isBuyer: this.isBuyer })),
                React.createElement("div", { className: "g-col-7 g-col-mobile-12" },
                    React.createElement("div", { className: "f-right mobile-d-none" },
                        React.createElement(decline_feedback_1.default, { orderUuid: this.props.orderUuid, onSuccess: this.declineFeedbackSuccess })),
                    React.createElement(feedback_form_1.default, { orderUuid: this.props.orderUuid, legacyOrderId: this.order && this.order.legacyOrderId, onSuccess: this.updateFeedbackSuccess, onError: this.updateFeedbackError, isBuyer: this.isBuyer, channel: this.channel })))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackContainer.prototype, "updateFeedbackSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackContainer.prototype, "updateFeedbackError", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackContainer.prototype, "declineFeedbackSuccess", null);
    tslib_1.__decorate([
        bind_1.default
    ], FeedbackContainer.prototype, "renderSuccessMessage", null);
    return FeedbackContainer;
}(React.Component));
exports.FeedbackContainer = FeedbackContainer;
exports.default = connect(FeedbackContainer);
var templateObject_1;
//# sourceMappingURL=feedback_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/feedbacks/feedback_container.js
// module id = Dawi
// module chunks = 20 21